import { useEffect, useState } from "react";

const THEME_KEY = "miqrapp-tema";

const savedTheme = () => {
    try {
        return window.localStorage.getItem(THEME_KEY);
    } catch (error) {
        return null;
    }
}

const systemDark = () => Boolean(window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches);

// Modo claro u oscuro de la landing y las páginas de ingreso. Sin elección guardada, sigue al sistema.
const useLandingTheme = () => {

    const [theme, setTheme] = useState(savedTheme);
    const [systemIsDark, setSystemIsDark] = useState(systemDark);
    const dark = theme ? theme === "dark" : systemIsDark;

    useEffect(() => {
        if (!window.matchMedia) return;
        const media = window.matchMedia("(prefers-color-scheme: dark)");
        const onChange = (e) => setSystemIsDark(e.matches);
        media.addEventListener ? media.addEventListener("change", onChange) : media.addListener(onChange);
        return () => media.removeEventListener ? media.removeEventListener("change", onChange) : media.removeListener(onChange);
    }, []);

    const toggleTheme = () => {
        const next = dark ? "light" : "dark";
        setTheme(next);
        try {
            window.localStorage.setItem(THEME_KEY, next);
        } catch (error) {
            // Sin almacenamiento (modo privado): el cambio dura hasta recargar.
        }
    }

    return { dark, toggleTheme };
}

export default useLandingTheme
